// import Cookies from "js-cookie";

import axios from "axios";

const DeleteCrop = async (payload) => {


    const token = JSON.parse(localStorage.getItem('authentication'));
    const config = {
        headers: { Authorization: `Bearer ${token}` },
    };
  
    try {
        const { data } = await axios.post(
            `${process.env.REACT_APP_BACKEND_API}/api/crop/DeleteCrop`,
            payload,
            config
        );
        return data
  
    } catch (error) {
      if (error.response) {
        return { status: error.response.status, payload: null };
      } else if (error.request) {
        return { status: 500, payload: null }; // Internal server error
      } else {
        return { status: 500, payload: null }; // Internal server error
      }
    }
  };
  
  export default DeleteCrop;
  